/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Glad_Lofty_Mouse_BuildInputs */

const fr_glad_lofty_mouse_build = /** @type {(inputs: Glad_Lofty_Mouse_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix`)
};

/**

* @param {Glad_Lofty_Mouse_BuildInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const glad_lofty_mouse_build = /** @type {((inputs?: Glad_Lofty_Mouse_BuildInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Glad_Lofty_Mouse_BuildInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_glad_lofty_mouse_build(inputs)
});